import { useEffect, useState } from "react";
import styles from "./taskquestions.module.css";
import { HelpCircle, Trash2 } from "react-feather";
import { Controller, useFieldArray, useWatch } from "react-hook-form";

const ANSWER_TYPES = ["Text", "Yes / No", "Radio Button", "Checkbox"];

function TextPreview() {
    return <p className={`${styles.previewHint}`}>Technician types a free-text answer…</p>;
}

function YesNoPreview() {
    return (<div className={`${styles.ynRow}`}>
        <div className={`${styles.ynBtn} ${styles.ynYes}`}>Yes</div>
        <div className={`${styles.ynBtn} ${styles.ynNo}`}>No</div>
    </div>);
}

function OptionsPreview({ square, control, index, setValue, isNew, prevTaskList }) {
    const [isNew2, setIsNew2] = useState(false);

    const { fields, append, remove } = useFieldArray({
        control,
        name: `taskList.${index}.answer_options`
    });

    useEffect(() => {
        if (!isNew && !isNew2) {
            prevTaskList[index]?.answer_options?.forEach((item2, index2) => {
                setValue(`taskList.${index}.answer_options.${index2}`, item2);
            });
        }
    }, [isNew, isNew2]);

    return (<div className={`${styles.optList}`}>
        {fields.map((field, i) => (<div key={field.id} className={`${styles.optRow}`}>
            <div className={`${styles.optBullet} ${square ? styles.optBulletSq : ""}`} />
            <Controller
                name={`taskList.${index}.answer_options.${i}`}
                control={control}
                render={(fieldV) => (
                    <input
                        {...fieldV}
                        className={styles.optInput}
                        type="text"
                        placeholder="Option…"
                    />
                )}
            />
            <button type="button" className={`${styles.optDel}`} onClick={() => remove(i)}>×</button>
        </div>))}

        <button type="button" className={`${styles.addOptBtn}`} onClick={() => {
            append("");
            setIsNew2(true);
        }}>+ Add option</button>
    </div>);
}

function AnswerPreview({ type, control, index, isNew, prevTaskList, setValue }) {
    if (type === "Yes / No") return <YesNoPreview />;
    if (type === "Radio Button") return <OptionsPreview key={`${index}-${type}`} control={control} index={index} square={false} prevTaskList={prevTaskList} isNew={isNew} setValue={setValue.bind(this)} />;
    if (type === "Checkbox") return <OptionsPreview key={`${index}-${type}`} control={control} index={index} square prevTaskList={prevTaskList} isNew={isNew} setValue={setValue.bind(this)} />;
    return <TextPreview />;
}

// ─── Question Panel ───────────────────────────────────────────

const QuestionPanel = ({ index, control, setValue, isNew, prevTaskList }) => {

    const answerType = useWatch({
        control,
        name: `taskList.${index}.question_type`,
        defaultValue: "Text"
    });

    const required = useWatch({
        control,
        name: `taskList.${index}.is_required`,
        defaultValue: 0
    });

    useEffect(() => {
        if (!isNew)
            setValue(`taskList.${index}.question`, prevTaskList[index]?.question);
    }, [isNew]);

    return (<div className={`${styles.questionPanel}`}>
        <p className={`${styles.qLabel}`}>Question</p>
        <Controller
            name={`taskList.${index}.question`}
            control={control}
            render={(field) => (<input
                {...field}
                className={`${styles.qInput}`}
                type="text"
                placeholder="Type your question here…"
            />)}
        />

        <p className={`${styles.qLabel}`}>Answer Type</p>
        <div className={`${styles.typeChips}`}>
            {ANSWER_TYPES.map((t) => (<button type="button" key={t} className={`${styles.typeChip} ${answerType === t ? styles.typeChipActive : ""}`} onClick={() => {
                control.setValue(`taskList.${index}.question_type`, t);
                if (t === "Radio Button" || t === "Checkbox") {
                    const current = control.getValues(`taskList.${index}.answer_options`);

                    if (!current || current.length === 0) {
                        control.setValue(`taskList.${index}.answer_options`, [""]);
                    }
                }

                if (t === "Text" || t === "Yes / No") {
                    control.setValue(`taskList.${index}.answer_options`, []);
                }
            }}>{t}</button>))}
        </div>

        <div className={`${styles.previewBox}`}>
            <AnswerPreview type={answerType} control={control} index={index} prevTaskList={prevTaskList} isNew={isNew} setValue={setValue.bind(this)} />
        </div>

        <div className={`${styles.requiredRow}`}>
            <button type="button" className={`${styles.toggle} ${required ? styles.toggleOn : ""}`} onClick={() => control.setValue(`taskList.${index}.is_required`, required ? 0 : 1)}>
                <div className={`${styles.toggleThumb} ${required ? styles.toggleThumbOn : ""}`} />
            </button>
            <span className={`${styles.requiredLabel}`}>Required answer</span>
        </div>
    </div>);
}

const TaskCard = ({ remove, index, errors, control, setValue, prevTaskList, isNew }) => {
    const [qOpen, setQOpen] = useState(false);

    useEffect(() => {
        if (!isNew) {
            setValue(`taskList.${index}.task_name`, prevTaskList[index]?.task_name);

            prevTaskList[index]?.answer_options?.forEach((item2, index2) => {
                setValue(`taskList.${index}.answer_options.${index2}`, item2);
            });
        }
    }, [isNew]);

    return (<>
        <div className={`${styles.taskCard}`}>
            <div className={`${styles.taskRow}`}>
                <Controller
                    name={`taskList.${index}.task_name`}
                    control={control}
                    render={(field) => (<input
                        {...field}
                        className={`${styles.taskInput}`}
                        type="text"
                        placeholder="Add a Task"
                    />)}
                />

                <div className={`${styles.taskActions}`}>
                    <button type="button" className={`${styles.iconBtn} ${qOpen ? styles.iconBtnActive : ""}`} title="Add question" onClick={() => setQOpen((v) => !v)}>
                        <HelpCircle />
                    </button>
                    <button type="button" className={`${styles.iconBtn} ${styles.iconBtnDel}`} title="Delete task" onClick={remove}>
                        <Trash2 />
                    </button>
                </div>
            </div>
            <div style={{ display: qOpen ? "block" : "none" }}>
                <QuestionPanel index={index} control={control} setValue={setValue.bind(this)} prevTaskList={prevTaskList} isNew={isNew} />
            </div>
        </div>

        {errors.taskList && errors?.taskList[index]?.task_name && (<p className={`${styles.ErrorM}`}>{errors?.taskList[index]?.task_name?.message}</p>)}

    </>);
}

const TaskQuestions = ({ fields, append, remove, control, errors, setValue, prevTaskList }) => {
    const [isNew, setIsNew] = useState(false);

    return (<div className={`${styles.container}`}>
        <p className={`${styles.title}`}>Tasks</p>

        <div className={`${styles.taskList}`}>
            {fields.map((item, index) => (
                <TaskCard key={item.id} index={index} remove={(e) => remove(index)} errors={errors} control={control} setValue={setValue.bind(this)} prevTaskList={prevTaskList} isNew={isNew} />
            ))}
            <button type="button" className={`${styles.addTaskBtn}`} onClick={(e) => {
                append({ task_name: "", question: "", question_type: "Text", is_required: 0, answer_options: [''] });
                setIsNew(true);
            }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                </svg>
                Add a Task
            </button>
        </div>

        
    </div>);
}

export default TaskQuestions;